/**
 * created by tian ruo jun
 资源统计页面
 *
 */
import React, {Component, useRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import BseTitle from "../../components/bseTitle/BseTitle";
import {Tabs} from "antd";
import ReactEcharts from "echarts-for-react";
import {HEADER_HEIGHT} from '../../../constants'
import headset from './image/headset5.svg';
import video1 from './image/video1.svg';
import file1 from './image/file1.svg';
import word1 from './image/word2.svg';
import picture1 from './image/picture1.svg';
import {resourceStatics,getResourceAllCount} from '../../../actions/statisticAnalysis';

const {TabPane} = Tabs;

export default class ResourceStatistics extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            flag:'1',
            titleData: [
                {icon: file1, title: '稿件数', month: '0', year: '0',type:'story', resourceType: '1',total:'0'},
                {icon: picture1, title: '图片数', month: '0', year: '0',type:'picture', resourceType: '2',total:'0'},
                {icon: video1, title: '视频数', month: '0', year: '0',type:'video', resourceType: '3',total:'0'},
                {icon: headset, title: '音频数', month: '0', year: '0',type:'audio', resourceType: '4',total:'0'},
                {icon: word1, title: '文件数', month: '0', year: '0',type:'files', resourceType: '5',total:'0'},
            ], // 各个媒体合计
            tabData: [
                {
                    tab: '稿件数',
                    refName:'manu',
                    resourceType: '1',
                    month: {},
                    year: {},
                    color:'70, 163, 248'
                },
                {
                    tab: '图片数',
                    refName:'pic',
                    resourceType: '2',
                    month: {},
                    year: {},
                    color:'251, 85, 85'
                },
                {
                    tab: '视频数',
                    refName:'vid',
                    resourceType: '3',
                    month: {},
                    year: {},
                    color:'82, 15, 108'
                },
                {
                    tab: '音频数',
                    refName:'aud',
                    resourceType: '5',
                    month: {},
                    year: {},
                    color:'40, 196, 69'
                },
                {
                    tab: '文件数',
                    refName:'file',
                    resourceType: '4',
                    month: {},
                    year: {},
                    color:'250, 209, 65'
                },
            ], // 各个媒体明细
        };
        this.state.tabData.forEach(item => {
            this[item.refName] = React.createRef();
        })
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getAllData();
        this.getResourceStatics();
    }
    // 获取后台数据
    getResourceStatics = () => {
        let paramsList = [
            [{type: 'month', resourceType: '1'}, {type: 'year', resourceType: '1'}],
            [{type: 'month', resourceType: '2'}, {type: 'year', resourceType: '2'}],
            [{type: 'month', resourceType: '3'}, {type: 'year', resourceType: '3'}],
            [{type: 'month', resourceType: '4'}, {type: 'year', resourceType: '4'}],
            [{type: 'month', resourceType: '5'}, {type: 'year', resourceType: '5'}],
        ];
        paramsList.forEach(item1 => {
            item1.forEach(item2 => {
                resourceStatics(item2, (res) => {
                    if (res) {
                        let data = res;
                        let a = item2.type;
                        let b = item2.resourceType;

                        let titleData = this.state.titleData;
                        let index2 = titleData.findIndex(item => item.resourceType === b);
                        this.state.titleData[index2][a] = this.format(data.total || '0');

                        delete data.total;

                        let tabData = this.state.tabData;
                        let index = tabData.findIndex(item => item.resourceType === b);
                        this.state.tabData[index][a] = data;
                        this.setState({})
                    }
                })
            })
        });
    };

    // 获取总数
    getAllData = () => {
        getResourceAllCount({},(res)=>{
            if(res){
                let titleData = this.state.titleData;
                titleData.forEach(item => {
                    item.total = this.format(res[item.type] || '0');
                    this.setState({})
                })
            }
        })
    };

    // 数字千分符
    format = (num) => {
        return num.toString().replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,');
    };
    // 文件类型切换
    tabChange = (key) => {
        console.log(key);
    };
    // 本年/历年切换
    dateChange=(v)=>{
        this.setState({flag:v});
    };

    render() {
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let titleData = this.state.titleData;
        let tabData = this.state.tabData;

        return (
            <div style={{height: height, background: '#fff'}}>
                {/*<BseTitle title={'资源统计'}/>*/}
                <div style={{height:28}}></div>
                <div style={{height: height - 28}}>
                    {/*title*/}
                    <div style={{height: 150, margin: '0 60px', display: 'flex', borderBottom: '1px solid #ebebeb'}}>
                        {titleData && titleData.length ? (
                            titleData.map((item, index) => (
                                <div key={index} style={{
                                    padding: '40px 0 0 5px',
                                    display: 'flex',
                                    flex: 1,
                                    borderRight: index < titleData.length - 1 ? '1px solid #ebebeb' : 'unset'
                                }}>
                                    <img src={item.icon} style={{height: 30, marginRight: 30}}/>
                                    <div style={{}}>
                                        <div style={{
                                            color: '#989898',
                                            textAlign: 'center',
                                            fontSize: 18
                                        }}>{item.title}</div>
                                        <div style={{fontSize: 30, color: '#666666'}}>
                                            {/*{this.state.flag === '1' ? item.month : item.year}*/}
                                            {item.total}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : null}
                    </div>
                    {/*tab*/}
                    <div className={'mediaBox'} style={{margin: '40px', height: height - 58 - 150 - 80, position: 'relative'}}>
                        <Tabs type="card" defaultActiveKey="0" onChange={this.tabChange}>
                            {tabData && tabData.length ? tabData.map((item, index) => (
                                <TabPane tab={item.tab} key={item.refName}>
                                    <div style={{height: height - 28 - 150 - 80 - 40,border:'1px solid #ebebeb'}}>
                                        <OneTab ref={this[item.refName]} tab={item.tab} dateChange={this.dateChange} color={item.color} thisYearData={item.month} overYearData={item.year}/>
                                    </div>
                                </TabPane>
                            )) : null}
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}

class OneTab extends Component {
    static defaultProps = {
        overYearData: [],
        thisYearData: [],
        tab: '数量',
    };
    static propTypes = {
        overYearData: PropTypes.object.isRequired,
        thisYearData: PropTypes.object.isRequired,
        tab: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            flag: '1', // 是否本年
        };
    }

    // 本年/历年 切换
    yearChange = (key) => {
        this.setState({flag: key});
        this.props.dateChange(key);
    };

    render() {
        let height = window.innerHeight - HEADER_HEIGHT;
        let dataX=[];
        let dataY=[];
        let month = this.props.thisYearData;
        let year = this.props.overYearData;
        let tab = this.props.tab;
        if (this.state.flag === '1') {
            for(let i in month) {
                dataX.push(i+'月');
                dataY.push(this.props.thisYearData[i]);
            }
        } else {
            for(let i in year) {
                dataX.push(i+'年');
                dataY.push(this.props.overYearData[i]);
            }
        }

        let option = {
            tooltip: {
                trigger: 'axis',
            },
            xAxis: {
                type: 'category',
                // boundaryGap: false,
                data: dataX,
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetX: 8,
                        shadowColor: '#7f7f7f'
                    },
                    symbol: ['none', 'arrow'],
                    symbolSize: [8, 8],
                    symbolOffset: 15
                },
                axisLabel: {
                    show: true,
                    interval: 0,
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize: 16,
                        padding: 20,

                    }
                },
                axisTick: {
                    show: false,
                }

            },

            yAxis: {
                // scale:true,
                // min:'dataMin',
                type: 'value',
                // splitNumber: 4,
                splitLine: {
                    lineStyle: {
                        // 使用深浅的间隔色
                        color: ['rgba(255,255,255,.1)']
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetY: -38,
                        shadowColor: '#7f7f7f'
                    },
                    symbol: ['none', 'arrow'],
                    symbolSize: [8, 8],
                    symbolOffset: 40
                },
                axisLabel: {
                    formatter: (value, index) => {
                        if(value < 1000) return value;
                        const si = [
                            {value: 1, symbol: ""},
                            {value: 1E3, symbol: "K"},
                            {value: 1E6, symbol: "M"},
                            {value: 1E9, symbol: "G"},
                            {value: 1E12, symbol: "T"},
                            {value: 1E15, symbol: "P"},
                            {value: 1E18, symbol: "E"}
                        ];
                        let i;
                        for (i = si.length - 1; i > 0; i--) {
                            if (value >= si[i].value) {
                                break;
                            }
                        }
                        return (value / si[i].value).toFixed(0) + si[i].symbol;
                        // return value.toFixed(3);
                    },
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize: 16
                    }
                },
                axisTick: {
                    show: false,
                }
            },
            series: [
                {
                    name: tab,
                    type: 'bar',
                    data: dataY,
                    barWidth: '25%',
                    label:{
                      normal:{
                          show:true,
                          formatter:(c)=>{
                              return c.value || ''
                          },
                          position:'top',
                          textStyle:{
                              color:'#000',
                              fontSize:14
                          }
                      },
                    },
                    itemStyle: {  /*设置折线颜色*/
                        normal: {
                            color: 'rgba('+(this.props.color || '3,253,214') +',.7)',
                            //     {
                            //     type: 'linear',
                            //     x: 0,
                            //     y: 0,
                            //     x2: 0,
                            //     y2: 1,
                            //     colorStops: [
                            //         {
                            //             offset: 0, color: 'rgba(3,253,214,1)',// 0% 处的颜色
                            //         },
                            //         {
                            //             offset: 0.5, color: 'rgba(3,253,214,.3)', // 100% 处的颜色
                            //         },
                            //         {
                            //             offset: 1, color: 'rgba(3,253,214,.001)'
                            //         }
                            //     ],
                            //     globalCoord: false // 缺省为 false
                            // },
                            // width: 1,
                        }
                    },
                }
            ],
            grid: {
                show: true,
                borderColor: 'transparent',
                x: 40,
                x2: 40,
                y: 60,
            },
        };
        return (
            <div style={{width: '100%', height: '100%'}}>
                <div className={'mediaBox'} style={{position: 'absolute', top: 0, right: 0}}>
                    <Tabs type="card" defaultActiveKey="1" onChange={this.yearChange} size={'small'}>
                        <TabPane tab="本年" key="1">
                        </TabPane>
                        <TabPane tab="历年" key="0">
                        </TabPane>
                    </Tabs>
                </div>
                <div style={{fontWeight: '700', padding: 20}}>资源趋势</div>
                <ReactEcharts
                    option={option}
                    notMerge={true}
                    lazyUpdate={true}
                    style={{width: '100%', height: height - 58 - 150 - 80 - 40 - 60}}
                />
            </div>
        )
    }

}
